import * as yup from "yup";

const requiredSchema = yup.object().shape({
  email: yup.string().email("Mail id invalid").required("Required"),
  note: yup.string().max("must have max 255 Characters"),
});

export {requiredSchema};